import { cn } from "../utils/cn";

export default function Card({
  as: Tag = "div",
  href,
  className = "",
  children,
  ...props
}) {
  const isLink = typeof href === "string" && href.length > 0;
  const Component = isLink ? "a" : Tag;

  return (
    <Component
      href={isLink ? href : undefined}
      className={cn(
        "hp-card",
        isLink && "hp-card-link",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
